export const BARRIER_AMOUNT = [
  { id: 'FLAT', displayValue: 'Flat' },
  { id: 'STEPPED', displayValue: 'Stepped' },
];

export const BARRIER_AMOUNT_WITH_CUSTOM = [
  ...BARRIER_AMOUNT,
  { id: 'CUSTOM', displayValue: 'Custom' },
];
